import React from "react"
import classNames from "classnames"
import { headerBits } from "../../../constants/tableConstants"

 const renderNormalRow = (row, byteIndex, onBitToggle, handleCellClick) => {
  const bit = row.bit;
  const active = row.value;
  
  return (
    <tr key={`row-${byteIndex}-${bit}`}>
      {headerBits.map(h => (
        <td 
          key={`c-${h}`} 
          className={classNames("text-center align-middle", { 
          })}
          style={{cursor: onBitToggle && h === bit ? 'pointer' : 'default', backgroundColor: (h === bit && active) ? '#d6f3e9' : '#ffffff'}}
          onClick={h === bit && onBitToggle ? () => handleCellClick(bit, active) : undefined}
          title={h === bit && onBitToggle ? "Click to toggle bit" : ""}
        >
          {h === bit ? (
            <span 
              style={{
              fontSize: '0.95rem',
              padding: '6px 4px'}}
              className={classNames("text-muted", { 
                "fw-bold": active,
                "user-select-none": onBitToggle
              })}>
              {active ? "1" : "0"}
            </span>
          ) : ""}
        </td>
      ))}
      <td className={classNames("text-start align-middle", { "table-success": active })} 
      style={{
        fontSize: '0.95rem', 
        lineHeight: '1.4', 
        padding: '10px 12px',
        backgroundColor: active ? '#d6f3e9' : '#ffffff'
        }}>
        {row.meaning}
      </td>
    </tr>
  );
}

export { renderNormalRow };
